import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { Sparkles, Bell, Lightbulb, FolderOpen, CalendarDays, BarChart3, Settings } from 'lucide-react';
import { toast } from 'sonner';

export const ToolRail = () => {
  const { data, setAdvisorOpen, tx } = useApp();
  const navigate = useNavigate();
  if (!data) return null;
  const unread = data.notifications.filter((n) => n.unread).length;

  const tools = [
    { key: 'advisor', icon: Sparkles, label: { es: 'Advisor', en: 'Advisor' }, onClick: () => setAdvisorOpen(true), accent: true },
    { key: 'notifications', icon: Bell, label: { es: 'Notificaciones', en: 'Notifications' }, onClick: () => navigate('/app/notifications'), badge: unread },
    { key: 'recommendations', icon: Lightbulb, label: { es: 'Recomendaciones', en: 'Recommendations' }, onClick: () => navigate('/app/recommendations') },
    { key: 'documents', icon: FolderOpen, label: { es: 'Documentos', en: 'Documents' }, onClick: () => navigate('/app/documents') },
    { key: 'calendar', icon: CalendarDays, label: { es: 'Calendario', en: 'Calendar' }, onClick: () => navigate('/app/calendar') },
    { key: 'forecast', icon: BarChart3, label: { es: 'Previsión', en: 'Forecast' }, onClick: () => navigate('/app/forecast') },
  ];

  return (
    <div
      className="app-chrome hidden xl:flex flex-col items-center fixed top-16 bottom-0 right-0 w-14 z-30 py-4 border-l"
      data-testid="tool-rail"
    >
      <div className="flex flex-col items-center gap-1.5">
        {tools.map((tItem) => (
          <button
            key={tItem.key}
            onClick={tItem.onClick}
            title={tx(tItem.label)}
            data-testid={`rail-${tItem.key}`}
            className={`relative w-10 h-10 rounded-xl flex items-center justify-center transition-colors group ${
              tItem.accent
                ? 'text-white'
                : 'text-zinc-500 hover:text-zinc-900 hover:bg-zinc-900/5 dark:text-zinc-300 dark:hover:text-white dark:hover:bg-white/10'
            }`}
            style={tItem.accent ? { background: 'linear-gradient(135deg, #06B6D4 0%, #7C3AED 100%)' } : undefined}
          >
            <tItem.icon className="w-[18px] h-[18px]" strokeWidth={2} />
            {tItem.badge > 0 && (
              <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-rose-500 text-white text-[9px] font-bold flex items-center justify-center">{tItem.badge}</span>
            )}
          </button>
        ))}
      </div>

      <div className="my-3 w-6 h-px bg-zinc-900/10 dark:bg-white/10" />

      <div className="flex flex-col items-center gap-2 flex-1 overflow-y-auto sidebar-scroll">
        {data.team.map((m) => (
          <button
            key={m.id}
            onClick={() => navigate('/app/team')}
            title={m.name}
            data-testid={`rail-team-${m.id}`}
            className="relative w-9 h-9 rounded-full overflow-hidden bg-zinc-900/10 ring-1 ring-zinc-900/15 dark:bg-white/10 dark:ring-white/20 hover:ring-cyan-400/60 transition-all shrink-0"
          >
            {m.avatar
              ? <img src={m.avatar} alt={m.name} className="w-full h-full object-cover" />
              : <span className="w-full h-full flex items-center justify-center text-zinc-700 dark:text-white text-xs font-semibold">{m.name[0]}</span>}
            {m.online && <span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-emerald-400 border-2 border-white dark:border-[#0b0e1c]" />}
          </button>
        ))}
      </div>

      <button
        onClick={() => toast(tx({ es: 'Ajustes del panel (demo)', en: 'Panel settings (demo)' }))}
        title={tx({ es: 'Configuración', en: 'Settings' })}
        data-testid="rail-settings"
        className="w-10 h-10 rounded-xl flex items-center justify-center text-zinc-500 hover:text-zinc-900 hover:bg-zinc-900/5 dark:text-zinc-400 dark:hover:text-white dark:hover:bg-white/10 transition-colors mt-2"
      >
        <Settings className="w-[18px] h-[18px]" />
      </button>
    </div>
  );
};
